import { OptionType } from '@evinced-private/ui-common';

import { ENVIRONMENT_LABEL_KEY, UNIT_ID_LABEL_KEY } from 'src/common/consts/platformConfigConsts';

import { IWfaLabelOptions } from '../services/WfaDashboardServiceTypes';

import { markWfaOptionsWithWarnings } from './markOptionsWithConfigurationWarnings';

interface ConfiguredValues {
	environment: Set<string>;
	unitId: Set<string>;
	environmentDisplayName: string;
	unitIdDisplayName: string;
}

export const applyWarningsToLabelOptions = (
	label: IWfaLabelOptions,
	configuredValues: ConfiguredValues
): OptionType[] => {
	const labelKeyLower = label.labelKey.toLowerCase();

	if (labelKeyLower === ENVIRONMENT_LABEL_KEY.toLowerCase()) {
		return markWfaOptionsWithWarnings(
			label.options,
			configuredValues.environment,
			configuredValues.environmentDisplayName
		);
	}

	if (labelKeyLower === UNIT_ID_LABEL_KEY.toLowerCase()) {
		return markWfaOptionsWithWarnings(
			label.options,
			configuredValues.unitId,
			configuredValues.unitIdDisplayName
		);
	}

	return label.options;
};
